export default {
    setBookingForm (state, data) {
        state.bookingForm = data
    },
    setBooking (state, booking) {
        state.booking = booking
    },
    setBookingChangelog (state, booking) {
        state.bookingChangelog = booking
    },
    setFollowOnJobsForTaxi (state, jobs) {
        state.followOnJobsForTaxi = jobs
    }
}
